import { createSlice } from "@reduxjs/toolkit";

// Define a Redux slice for managing authentication state
const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: localStorage.getItem('token'),
    isLoggedIn: !!localStorage.getItem('token'),
    user: JSON.parse(localStorage.getItem("user")) || null,
  },
  reducers: {
    setAuthData(state, action) {
      state.token = action.payload;
      state.isLoggedIn = true;
      state.user = action.payload.user;
      localStorage.setItem('token', action.payload);
      localStorage.setItem("user", JSON.stringify(action.payload.user));
    },
    removeToken(state) {
      state.token = null;
      state.isLoggedIn = false;
      state.user = null;
      localStorage.removeItem('token');
      localStorage.removeItem("user");
    },
  },
});

// Export actions and reducer from the auth slice
export const { setToken, removeToken,setAuthData } = authSlice.actions;



export const authReducer = authSlice.reducer;